import template from './simpleContactsList.template.html';

export default {
  template,
  bindings: {
    contacts: '<'
  },
controller: class controller {
    constructor() {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {};

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
